import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { CollapsableToggleItemHeadI } from '../collapsable-toggle-item-head/collapsable-toggle-item-head.component';
import CollapsableToggleItem, {
    CollapsableToggleItemI,
} from '../collapsable-toggle-item/collapsable-toggle-item.component';
import { Text } from '../text/text';
export interface CollapsableToggleI {
    header: CollapsableToggleItemHeadI;
    items: CollapsableToggleItemI[];
    className?: string;
    visibleItems?: number;
    emptyStateMessage?: string;
    children?: ReactNode;
}
const ITEM_HEIGHT = 48;
const CollapsableToggle: FC<CollapsableToggleI> = ({
    header,
    items,
    className,
    children,
    visibleItems = 3,
    emptyStateMessage = 'No hay vehículos disponibles',
}) => {
    return (
        <div
            className={twMerge(
                'shadow-[0px_3px_10px_0px_rgba(20,115,247,0.12)] rounded border border-gray-50 ',
                className,
            )}
            data-testid="collapsable-toggle"
        >
            <CollapsableToggleItem item={header} id={header.id}>
                {children}
                {items && items.length > 0 ? (
                    <div className={twMerge('overflow-auto')} style={{ maxHeight: ITEM_HEIGHT * visibleItems }}>
                        {items.map((item: CollapsableToggleItemI) => {
                            return <CollapsableToggleItem {...item} />;
                        })}
                    </div>
                ) : (
                    <div className="flex w-full p-4 justify-center">
                        <Text weight="medium" size="14" lineHeight="16">
                            {emptyStateMessage}
                        </Text>
                    </div>
                )}
            </CollapsableToggleItem>
        </div>
    );
};

export default CollapsableToggle;
